<template>
  <VTextarea
    :label="label"
    :value="value"
    :required="required"
    :disabled="disabled"
    :persistent-hint="!!info"
    :hint="info"
    auto-grow
    :rules="required ? isRequired : []"
    @input="$emit('change', {val: $event, name: name})"
  />
</template>
<script>
  import defaultProps from './props.js'
  export default {
    props: [...defaultProps.default],
    data () {
      return {
        isRequired: [
          (value) => {
            if (value?.length > 0) return true
            return `${this.label || this.name} ist erforderlich.`
          },
          (v) =>
            (v && v.length <= 1000) ||
            'Maximal 1000 Zeichen, bitte text kürzen.',
        ],
      }
    },
  }
</script>
